import ENDPOINTS from '../../../constants/apiEndPoints';
import { axiosInstance } from '../../axiosInstance';
import type { ApiResponse } from '../../axiosInstance';
import type { DaySummaryRows, SummaryDeliveryState } from './types';

type DaySummaryResponse = ApiResponse<{
  rows: DaySummaryRows;
  delivery?: SummaryDeliveryState;
}>;

export const handleGetDaySummaryService = async (): Promise<DaySummaryResponse> => {
  const response = await axiosInstance.get(ENDPOINTS.GET_DAY_SUMMARY);
  return response?.data;
};

export const handleGetDaySummaryStatusService = async (): Promise<
  ApiResponse<SummaryDeliveryState>
> => {
  const response = await axiosInstance.get(ENDPOINTS.GET_DAY_SUMMARY_STATUS);
  return response?.data;
};

export const handleAcknowledgeDaySummaryService = async (): Promise<
  ApiResponse<SummaryDeliveryState>
> => {
  const response = await axiosInstance.post(ENDPOINTS.ACKNOWLEDGE_DAY_SUMMARY);
  return response?.data;
};
